import { lgpClient } from "@lgp/shared/utils/LGPApiClient";
import { useContext, useEffect, useMemo, useState } from "react";
import { Col, Row, Spinner } from "reactstrap";
import Check from "../svg/check.svg";
import { appContext } from "./AppProvider";
import SvgIcon from "./SvgIcon";

async function match(url, data) {
  const matchRes = await lgpClient.makeRequest("POST", url, {
    data,
  });

  return matchRes;
}

function SearchSection(props) {
  const { appState, formState, triggerPostMessage } = useContext(appContext);
  const { show, section, setNextSection } = props;
  const [state, setState] = useState({
    currentStep: 0,
    totalSteps: 0,
    matchCompleted: false,
    matched: false,
  });

  // Redirect to TT.
  const redirectUrl = useMemo(() => {
    if (!appState.ttRedirectUrl) {
      return null;
    }

    const redirectUrlObj = new URL(appState.ttRedirectUrl);
    redirectUrlObj.searchParams.append("zipCode", formState.data.Zip);
    redirectUrlObj.searchParams.append("category", formState.data.Project);
    return redirectUrlObj.href;
  }, [formState.data.Zip, formState.data.Project, appState.ttRedirectUrl]);

  // Effect used the first time show is set to true.
  useEffect(() => {
    const matchAsync = async () => {
      let matchRes;

      if (!redirectUrl || !formState.data.Zip) {
        matchRes = {
          status: "matched",
        };
      } else {
        try {
          matchRes = await match(appState.matchEndpoint, formState.data);
        } catch (err) {
          matchRes = {
            status: "failed",
            error: err.message,
          };
        }
      }

      setState((prevState) => ({
        ...prevState,
        matchCompleted: true,
        matched: matchRes.status === "matched",
      }));
    };

    if (show) {
      // Set the total steps.
      setState((prevState) => ({
        ...prevState,
        totalSteps: section.steps.length,
        matchCompleted: false,
      }));

      // Fire request to fetch the match info.
      matchAsync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, redirectUrl, formState.data.Zip]);

  useEffect(() => {
    if (show && state.currentStep < state.totalSteps) {
      const id = setTimeout(() => {
        setState((prevState) => {
          // Don't advance to the last step if the ping is not completed.
          if (
            prevState.currentStep + 1 === state.totalSteps &&
            !prevState.matchCompleted
          ) {
            return {
              ...prevState,
            };
          }

          // Advance to the next step.
          return {
            ...prevState,
            currentStep: prevState.currentStep + 1,
          };
        });
      }, 1000);

      return () => clearTimeout(id);
    }
  }, [
    show,
    state.currentStep,
    state.totalSteps,
    state.matchCompleted,
    setState,
  ]);

  useEffect(() => {
    if (
      show &&
      state.matchCompleted &&
      state.currentStep === state.totalSteps
    ) {
      if (state.matched) {
        const id = setTimeout(() => {
          setNextSection();
        }, 500);

        return () => clearTimeout(id);
      } else {
        // Redirect to TT.
        const id = setTimeout(() => {
          triggerPostMessage("lgp:redirect", null, {
            url: redirectUrl,
          });
        }, 1500);

        return () => clearTimeout(id);
      }
    }
  }, [
    show,
    state.currentStep,
    state.totalSteps,
    state.matchCompleted,
    state.matched,
    redirectUrl,
    setNextSection,
    triggerPostMessage,
  ]);

  if (!show) {
    return null;
  }

  return (
    <Row className="mslf-form-content-row mb-3 justify-content-center">
      <Col
        xs={12}
        sm={12}
        md={10}
        className="project-search-container text-center"
      >
        <h3 className="h3 mt-2 mb-5 d-none d-md-block">
          {section["lf-question"]}
        </h3>
        <h5 className="h5 mt-2 mb-5 d-md-none">{section["lf-question"]}</h5>
        <ul>
          {section.steps.map((step, i) => (
            <li key={`${step}_${i}`}>
              {state.currentStep <= i ? (
                <>
                  <div className="icon">
                    <Spinner color="primary" type="grow">
                      Loading...
                    </Spinner>{" "}
                  </div>
                  <div className="h5 fw-normal text text-muted">{step}</div>
                </>
              ) : (
                <>
                  <SvgIcon id="check" href={Check} className="icon" />
                  <div className="h5 fw-normal text">{step}</div>
                </>
              )}
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
}

export default SearchSection;
